import React from 'react';

const EditUserModal = ({
  isOpen,
  onClose,
  editForm,
  onInputChange,
  onSubmit,
  successMessage,
  errorMessage,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-lg w-[480px] max-w-full mx-4 shadow-xl">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">Editar Usuario</h2>
        <form onSubmit={onSubmit} className="space-y-4">
          <input
            name="cedula"
            value={editForm.cedula}
            onChange={onInputChange}
            placeholder="Cedula"
            required
            className="w-full px-4 py-2 bg-white border text-gray-500 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-200"
          />
          <input
            name="name"
            value={editForm.name}
            onChange={onInputChange}
            placeholder="Nombre"
            required
            className="w-full px-4 py-2 bg-white border text-gray-500 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-200"
          />
          <input
            name="email"
            type="email"
            value={editForm.email}
            onChange={onInputChange}
            placeholder="Email"
            required
            className="w-full px-4 py-2 bg-white border text-gray-500 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-200"
          />
          <select
            name="rol"
            value={editForm.rol}
            onChange={onInputChange}
            className="w-full px-4 py-2 bg-white border text-gray-500 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-200"
          >
            <option value="Profesor">Profesor</option>
            <option value="Administrador">Administrador</option>
          </select>
          <select
            name="estado"
            value={editForm.estado}
            onChange={onInputChange}
            className="w-full px-4 py-2 bg-white border text-gray-500 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-200"
          >
            <option value="Activa">Activa</option>
            <option value="Desactivada">Desactivada</option>
          </select>
          <div className="flex justify-end space-x-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-6 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors duration-200 font-medium"
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="px-6 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors duration-200 font-medium"
            >
              Guardar
            </button>
          </div>
        </form>
        {successMessage && <p className="mt-4 text-green-600">{successMessage}</p>}
        {errorMessage && <p className="mt-4 text-red-600">{errorMessage}</p>}
      </div>
    </div>
  );
};

export default EditUserModal;
